import { render, staticRenderFns } from "./template.html?vue&type=template&id=bb84b49e&scoped=true&"
import script from "./FormKeywordRecommendEn.vue?vue&type=script&lang=ts&"
export * from "./FormKeywordRecommendEn.vue?vue&type=script&lang=ts&"
import style0 from "./style.scss?vue&type=style&index=0&id=bb84b49e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb84b49e",
  null
  
)

export default component.exports